export class CustomEmailEditPanePopUpModal {
  public static createEmpty(): CustomEmailEditPanePopUpModal {
    return new CustomEmailEditPanePopUpModal();
  }
  constructor(
    public Heading: string = '',
    public ModelDescription: string = '',
    public InputType: number = 0,
    public IsIconVisible: boolean = false,
    public IsMergeTagsOpen: boolean = false,
    public Placeholder: string = '',
    public IconURL: any = '',
    public Button1Text: string = '',
    public Button2Text: string = '',
    public ShowButton1: boolean = true,
  ) { }
}
